import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Radio, Button } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { FormComponentProps } from 'antd/lib/form';
import {
  PoiCodePreference,
  PoiCreateMinimumRole
} from '../../../common/api/spidertracks-sdk/types/PointOfInterest';
import { updatePoiPreferences } from '../../../redux/slice/poiAdmin/thunk';
import {
  getPoiCodePreference,
  getPoiCreateMinimumRole,
  getPoiPreferenceUpdating
} from '../../../redux/selectors/poiAdmin';
import {
  setPoiCodePreference,
  setPoiCreateMinimumRole
} from '../../../redux/slice/poiAdmin/poiAdmin';

interface ComponentProps extends FormComponentProps {
  organisationId: string;
}

// eslint-disable-next-line react/prop-types
const PoiPreferencesForm: React.FC<ComponentProps> = ({ organisationId, form }) => {
  const dispatch = useDispatch();
  const poiCodePreference = useSelector(getPoiCodePreference);
  const poiCreateMinimumRole = useSelector(getPoiCreateMinimumRole);
  const poiPreferenceUpdating = useSelector(getPoiPreferenceUpdating);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    form.validateFields(err => {
      if (!err) {
        dispatch(updatePoiPreferences(organisationId));
        form.resetFields();
      }
    });
  };

  const isFormDirty = form.isFieldsTouched(['poiCodePreference', 'poiCreateMinimumRole']);

  const handlePoiCodePreferenceChange = (e: RadioChangeEvent) => {
    dispatch(setPoiCodePreference(e.target.value));
  };

  const handlePoiCreateMinimumRoleChange = (e: RadioChangeEvent) => {
    dispatch(setPoiCreateMinimumRole(e.target.value));
  };

  return (
    <Form onSubmit={handleSubmit} layout="vertical">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
        <div>
          <Form.Item
            label={
              <div>
                <h4>Location Priority</h4>
              </div>
            }
          >
            {form.getFieldDecorator('poiCodePreference', {
              initialValue: poiCodePreference
            })(
              <Radio.Group onChange={handlePoiCodePreferenceChange}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Radio value={PoiCodePreference.ICAO}>{'Custom > ICAO > IATA > Other'}</Radio>
                  <Radio value={PoiCodePreference.IATA}>{'Custom > IATA > ICAO > Other'}</Radio>
                </div>
              </Radio.Group>
            )}
          </Form.Item>
        </div>

        <div>
          <Form.Item
            label={
              <div>
                <h4>Create Permission</h4>
              </div>
            }
          >
            {form.getFieldDecorator('poiCreateMinimumRole', {
              initialValue: poiCreateMinimumRole
            })(
              <Radio.Group onChange={handlePoiCreateMinimumRoleChange}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <Radio value={PoiCreateMinimumRole.ADMIN}>
                    Only Admins can create new Locations
                  </Radio>
                  <Radio value={PoiCreateMinimumRole.MEMBER}>
                    All Members can create new Locations
                  </Radio>
                </div>
              </Radio.Group>
            )}
          </Form.Item>
        </div>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={poiPreferenceUpdating}
            disabled={poiPreferenceUpdating || !isFormDirty}
          >
            {poiPreferenceUpdating ? 'Saving...' : 'Save'}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
};

export default Form.create<ComponentProps>()(PoiPreferencesForm);
